import * as yup from 'yup'

export default defineNuxtPlugin((nuxtApp) => {
  const { t } = nuxtApp.$i18n || nuxtApp.vueApp.config.globalProperties.$t

  yup.setLocale({
    mixed: {
      required: ({ params }) => t('forms.errors.fieldRequired', params),
      default: ({ message, params }) => {
        if (typeof message === 'string') {
          return t(message, params) // <— теперь ключи в .test тоже переведутся
        }
        return message
      },
    },
    string: {
      min: ({ min, params }) =>
        t('forms.errors.min-length', { count: min, ...params }),
      max: ({ max, params }) =>
        t('forms.errors.max-length', { count: max, ...params }),
      matches: ({ params }) => t('forms.errors.only_letters', params),
      email: ({ params }) => t('forms.errors.invalidEmail', params),
    },
    number: {
      min: ({ min, params }) =>
        t('forms.errors.min-number', { count: min, ...params }),
      max: ({ max, params }) =>
        t('forms.errors.max-number', { count: max, ...params }),
    },
    date: {
      min: ({ min, params }) =>
        t('forms.errors.min-date', { date: min, ...params }),
      max: ({ max, params }) =>
        t('forms.errors.max-date', { date: max, ...params }),
    },
  })
})
